module.exports = __webpack_public_path__ + "static/media/relatos-anfibios-2.4a503cb7.png";